import React, { useState, useContext, useEffect } from "react";
import "./Passion.css";
import { useNavigate } from "react-router-dom";
import BackgroundSlider from "../../BackGround/BackgroundSlider";
import Logo from "../../../images/Logo.png";
import sportsList from "./SportsList";
import SportCard from "./SportsCard";
import SkillLevelTrack from "./SkillLevelTrack";
import BackIcon from "../../../images/BackIcon.png";
import { toast, ToastContainer } from "react-toastify";
import RegisterContext from "../../../../createContext/Register/RegisterContext";

function Passion() {
  const navigate = useNavigate();
  const { setPassionData, loading } = useContext(RegisterContext);
  const [selectedSports, setSelectedSports] = useState({});
  const [modalState, setModalState] = useState({
    isOpen: false,
    currentSport: null,
  });

  // Get isEditing from localStorage with a default value of false
  const [isEditing] = useState(() => {
    const editingState = localStorage.getItem("isEditing");
    return editingState ? JSON.parse(editingState) : false;
  });

  const handleSportClick = (sport) => {

    if (selectedSports[sport.name]) {
      const updatedSports = { ...selectedSports };
      delete updatedSports[sport.name];
      setSelectedSports(updatedSports);
    } else {
      setModalState({ isOpen: true, currentSport: sport });
    }
  };

  const handleSkillLevelSelect = (skillLevel) => {
    const sport = modalState.currentSport;
    setSelectedSports((prev) => ({
      ...prev,
      [sport.name]: skillLevel,
    }));
    setModalState({ isOpen: false, currentSport: null });
  };

  const handleCloseModal = () => {
    setModalState({ isOpen: false, currentSport: null });
  };

  const handleBackClick = () => {
    if (isEditing) {
      localStorage.removeItem("isEditing");
      navigate('/profile');
    } else {
      navigate(-1);
    }
  };

  const handleNextClick = async () => {
    if (Object.keys(selectedSports).length === 0) {
      toast.error("Please select at least one sport!");
      return;
    }

    try {
      const response = await setPassionData(selectedSports);

      if (response.success) {
        if (isEditing) {
          localStorage.removeItem("isEditing");
          navigate("/profile");
        } else {
          navigate("/register/uploadPicture");
        }
      } else {
        toast.error(response.message || "Something went wrong.");
      }
    } catch (err) {
      toast.error("An error occurred while submitting the data.");
    }
  };

  const handleSkipClick = () => {
    navigate("/register/uploadPicture");
  };
  useEffect(() => {
    // Load previously saved passions from localStorage when editing
    if (isEditing) {
      const savedPassions = localStorage.getItem("userPassions");
      if (savedPassions) {
        const parsedPassions = JSON.parse(savedPassions);
  
        // Transform the passions to the desired format
        const transformedPassions = {};
        Object.entries(parsedPassions).forEach(([key, value]) => {
          if (typeof value === "object" && value.name && value.skillLevel) {
            transformedPassions[value.name] = value.skillLevel;
          } else {
            transformedPassions[key] = value;
          }
        });
  
        setSelectedSports(transformedPassions);
      }
    }

  }, [isEditing]);

  useEffect(() => {
    const savedPassionData = sessionStorage.getItem("passionData");
    if (savedPassionData) {
      setSelectedSports(JSON.parse(savedPassionData));
    }

    // Cleanup function to remove isEditing from localStorage when component unmounts
    return () => {
      if (isEditing) {
        localStorage.removeItem("isEditing");
        localStorage.removeItem("userPassions");
      }
    };
  }, []);

  return (
    <>
      <div className="header">
        <img src={Logo} alt="Fisko" className="Logo" />
      </div>
      <div className="passion-page">
        <BackgroundSlider />
        <div className="passion-box">
          <main className="passionContainer">
            <header className="headerSection">
              <h1 className="title">
                {isEditing ? "Edit Your Passions" : "Choose Your Passion"}
              </h1>
              <h2 className="subtitle">
                Select the area you're most interested in
              </h2>
            </header>
            <img
              src={BackIcon}
              alt="Back"
              className="backIcon"
              onClick={handleBackClick}
            />
            <main className="p_container">
              {sportsList.map((sport) => (
                <SportCard
                  key={sport.name}
                  name={sport.name}
                  followers={sport.followers}
                  imageUrl={sport.imageUrl}
                  isActive={!!selectedSports[sport.name]}
                  onClick={() => handleSportClick(sport)}
                />
              ))}
            </main>
            <button
              type="button"
              className="submitButton"
              onClick={handleNextClick}
            >
              {isEditing ? "Save Changes" : "Let's Go"}
            </button>
            {!isEditing && (
              <button
                type="button"
                className="Skip"
                onClick={handleSkipClick}
              >
                Skip!
              </button>
            )}
          </main>
        </div>
      </div>
      {modalState.isOpen && (
        <SkillLevelTrack
          sport={modalState.currentSport}
          onSkillLevelSelect={handleSkillLevelSelect}
          onClose={handleCloseModal}
        />
      )}
      <ToastContainer />
    </>
  );
}

export default Passion;